import Grid from "@material-ui/core/Grid";
import React from "react";
import { CardElement } from "react-stripe-elements";
import Button from "../../FormElement/Button";
import InputFiled from "../../FormElement/InputFiled";

export default function PaymentForm(props) {
  return (
    <React.Fragment>
      <Grid
        container
        spacing={8}
        style={{ display: "flex", justifyContent: "center" }}
      >
        <Grid item xs={12} sm={7} style={{ marginBottom: "20px" }}>
          <InputFiled
            value={props.values.cardHolderName}
            label="Card Holder Name"
            type="text"
            name="cardHolderName"
            handleChange={props.handleChange("cardHolderName")}
            validations={["maxSize"]}
          />
        </Grid>
        <Grid item xs={12} sm={7}>
          <div
            style={{
              border: "1px solid rgba(0, 0, 0, 0.23)",
              borderRadius: 3,
              padding: 17
            }}
          >
            <CardElement style={{ base: { fontSize: "18px" } }} />
          </div>
        </Grid>
        <Grid
          item
          xs={7}
          style={{
            display: "flex",
            justifyContent: "center",
            paddingTop: 10,
            whiteSpace: "nowrap"
          }}
        >
          <Button
            onclick={props.handleSubmit}
            name={props.btnLabel}
            disabled={props.isDisabled}
          />
        </Grid>
      </Grid>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/public/Checkout/PaymentForm.js